
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-opportunity/[id]/[title]",
      function () {
        return require("private-next-pages/learning-opportunity/[id]/[title].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-opportunity/[id]/[title]"])
      });
    }
  